module.exports = "/images/ly.svg?b6afe729a1fe15979dda3bc27099accc";